// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2A7m5","right":"styles_right__TmCpr"};